export default {
	namespaced: true,
	state: {
		packagesURL: '/packages/',
		cloneURL: '/clone',
		paymentProvidersURL: '/packages/payment-providers',
		packagePaymentURL: '/payment/',
		paymentConnectionsURL: '/packages/payment/connections',
	},
	getters: {
		getPackagesURL(state){
			return state.packagesURL;
		},
		getPackageCloneURL(state){
			return state.cloneURL;
		},
		getPaymentProvidersURL(state){
			return state.paymentProvidersURL;
		},
		getPackagePaymentURL(state){
			return state.packagePaymentURL;
		},
		getPaymentConnectionsURL(state){
			return state.paymentConnectionsURL;
		},
	},
}
